module.exports = __webpack_public_path__ + "img/2.dc4cf64.png";